export default __webpack_public_path__ + "static/media/banscan.e7aae347.png";